import type { ObjectivePeriodStatusType } from '@/constants/ObjectivePeriodStatus';
import type { ObjectivePeriod, ObjectivePeriodRequest } from '@/types/objective-periods';

import { api } from '@/api/api';

export default {
    /** Served most recent first (start date descending); `status` narrows the list server-side. */
    async getObjectivePeriods(status?: ObjectivePeriodStatusType): Promise<ObjectivePeriod[]> {
        const response = await api.get('/ObjectivePeriod', {
            params: status ? { status } : undefined,
        });
        return response.data;
    },

    async getObjectivePeriodById(id: string): Promise<ObjectivePeriod> {
        const response = await api.get(`/ObjectivePeriod/${id}`);
        return response.data;
    },

    async createObjectivePeriod(request: ObjectivePeriodRequest): Promise<ObjectivePeriod> {
        const response = await api.post('/ObjectivePeriod', request);
        return response.data;
    },

    async updateObjectivePeriod(
        id: string,
        request: ObjectivePeriodRequest,
    ): Promise<ObjectivePeriod> {
        const response = await api.put(`/ObjectivePeriod/${id}`, request);
        return response.data;
    },

    async setObjectivePeriodStatus(
        id: string,
        status: ObjectivePeriodStatusType,
    ): Promise<ObjectivePeriod> {
        const response = await api.patch(`/ObjectivePeriod/${id}/Status`, { status });
        return response.data;
    },

    /** The deleted period comes back with `linkedObjectivesCount` = objectives just orphaned. */
    async deleteObjectivePeriod(id: string): Promise<ObjectivePeriod> {
        const response = await api.delete(`/ObjectivePeriod/${id}`);
        return response.data;
    },
};
